import * as React from 'react';
import PropTypes from 'prop-types';

import { Build, Pages } from '@material-ui/icons';

import {
    FoodIcon, BudskapIcon, TrophyIcon,
} from './index';

export const getElementIcon = (item) => {
    if (item) {
        const itemName = item.name?.toLowerCase();
        if (item.Icon) {
            return item.Icon;
        } if (itemName.indexOf('trening') > -1) {
            return TrophyIcon;
        } if (itemName.indexOf('budskap') > -1) {
            return BudskapIcon;
        } if (itemName.indexOf('kjøkken') > -1) {
            return FoodIcon;
        } if (itemName.indexOf('hverdagsmat') > -1) {
            return FoodIcon;
        } if (itemName.indexOf('gla:d') > -1) {
            return TrophyIcon;
        } if (itemName.indexOf('verktøy') > -1) {
            return Build;
        }
    }
    return Pages;
}

const ElementIconOrDefault = ({ item, ...props }) => {
    const Icon = getElementIcon(item);
    return (<Icon {...props} />);
};

ElementIconOrDefault.propTypes = {
    item: PropTypes.object,
};

ElementIconOrDefault.defaultProps = {
    item: null,
};

export default ElementIconOrDefault;
